module.exports = __webpack_public_path__ + "static/media/Stay_at_home_requirements_timeline.df75a1c3.svg";